import {dom as $7230ffa83bc0c2cf$export$df3a06d6289f983e, useContextProps as $7230ffa83bc0c2cf$export$29f1550f4b0d4415} from "./utils.mjs";
import {createLeafComponent as $gfOZh$createLeafComponent} from "react-aria/CollectionBuilder";
import {HeaderNode as $gfOZh$HeaderNode} from "react-aria/private/collections/BaseCollection";
import $gfOZh$react, {createContext as $gfOZh$createContext} from "react";

/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 



const $53e61d82d8b8611d$export$e0e4026c12a8bdbb = /*#__PURE__*/ (0, $gfOZh$createContext)({});
const $53e61d82d8b8611d$export$8b251419efc915eb = /*#__PURE__*/ (0, $gfOZh$createLeafComponent)((0, $gfOZh$HeaderNode), function Header(props, ref) {
    [props, ref] = (0, $7230ffa83bc0c2cf$export$29f1550f4b0d4415)(props, ref, $53e61d82d8b8611d$export$e0e4026c12a8bdbb);
    return /*#__PURE__*/ (0, $gfOZh$react).createElement((0, $7230ffa83bc0c2cf$export$df3a06d6289f983e).header, {
        className: "react-aria-Header",
        ...props,
        ref: ref
    }, props.children);
});


export {$53e61d82d8b8611d$export$e0e4026c12a8bdbb as HeaderContext, $53e61d82d8b8611d$export$8b251419efc915eb as Header};
//# sourceMappingURL=Header.mjs.map
